/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type UserWidget_user$ref = any;
export type RunLogType = "PROGRESS_ENTRY" | "RUN_END" | "RUN_PAUSE" | "RUN_START" | "SETUP_END" | "SETUP_PAUSE" | "SETUP_START";
import type { FragmentReference } from "relay-runtime";
declare export opaque type RunLogs_run$ref: FragmentReference;
declare export opaque type RunLogs_run$fragmentType: RunLogs_run$ref;
export type RunLogs_run = {|
  +id: string,
  +yields: {|
    +edges: ?$ReadOnlyArray<?{|
      +setupQuantity: ?number,
      +runQuantity: ?number,
      +defectQuantity: ?number,
      +node: {|
        +id: string,
        +item: {|
          +id: string,
          +name: string,
        |},
      |},
    |}>
  |},
  +machine: {|
    +id: string
  |},
  +logs: $ReadOnlyArray<{|
    +id: string,
    +type: RunLogType,
    +notes: ?string,
    +createdAt: any,
    +user: {|
      +$fragmentRefs: UserWidget_user$ref
    |},
  |}>,
  +$refType: RunLogs_run$ref,
|};
export type RunLogs_run$data = RunLogs_run;
export type RunLogs_run$key = {
  +$data?: RunLogs_run$data,
  +$fragmentRefs: RunLogs_run$ref,
};
*/


const node/*: ReaderFragment*/ = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Fragment",
  "name": "RunLogs_run",
  "type": "Run",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    (v0/*: any*/),
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "yields",
      "storageKey": null,
      "args": null,
      "concreteType": "RunYieldConnection",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "edges",
          "storageKey": null,
          "args": null,
          "concreteType": "RunYieldEdge",
          "plural": true,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "setupQuantity",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "runQuantity",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "defectQuantity",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "node",
              "storageKey": null,
              "args": null,
              "concreteType": "JobYield",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "item",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "Item",
                  "plural": false,
                  "selections": [
                    (v0/*: any*/),
                    {
                      "kind": "ScalarField",
                      "alias": null,
                      "name": "name",
                      "args": null,
                      "storageKey": null
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "machine",
      "storageKey": null,
      "args": null,
      "concreteType": "Machine",
      "plural": false,
      "selections": [
        (v0/*: any*/)
      ]
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "logs",
      "storageKey": null,
      "args": null,
      "concreteType": "RunLog",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "type",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "notes",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "createdAt",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "user",
          "storageKey": null,
          "args": null,
          "concreteType": "User",
          "plural": false,
          "selections": [
            {
              "kind": "FragmentSpread",
              "name": "UserWidget_user",
              "args": null
            }
          ]
        }
      ]
    }
  ]
};
})();
// prettier-ignore
(node/*: any*/).hash = '81aba413e85ea1b89cf5d95ed95736df';
module.exports = node;
